/**
 * Default Guards
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import store from '@/store/store'

export default {
  /**
   * Dispatches by default a store query command
   * and applies the next callback
   * @param {string} storeName - The name of the store
   * @param {object} queryParams - Additional query parameters to be send in the request
   * @returns {function(*, *, *): Promise<T>}
   */
  onQuery (storeName, queryParams = {}) {
    return function (to, from, next) {
      store.dispatch(storeName + '/query', {...to.query, ...queryParams})
        .then(response => {
          next()
        })
        .catch(error => {
          next(error)
        })
    }
  },
  /**
   *
   * @param storeName
   * @param options
   * @returns {Function}
   */
  onGet (storeName, options = {}) {
    return function (to, from, next) {
      next(store.dispatch(storeName + '/get', {id: to.params.id, ...options}))
    }
  }
}



// WEBPACK FOOTER //
// ./src/guards/default.guards.js